 
import { API_SITE_CORPO } from './api_endpoint';
import { http, httpwithtoken  } from './http';
 

export const gallery = async () => {  
	
	try {
		let x=API_SITE_CORPO.MEDIA
		// console.log(x)
		let { data } = await http.get(x);

		return data;
	} catch (error) {
		console.error(error); 
		 
	}
};

export const getPagenation = async () => {  
	
	try {
		let x=API_SITE_CORPO.MEDIA_PAGE
		// console.log(x)
		let res = await http.get(x);

		return res;
	} catch (error) {
		console.error(error); 
		 
	}
};
export const getmedia = async (id:any) => {  
	
	try {
		let x=API_SITE_CORPO.MEDIA+id
		// console.log(x)
		let { data } = await http.get(x);

		return data;
	} catch (error) {
		console.error(error); 
		 
	}
};

export const getMediaByUrl = async (slug: string)=>{

	// console.log(slug);

	try {
		let x=API_SITE_CORPO.PAGE+"/"+slug
		// console.log(x)
		let { data } = await http.get(x);
		return data;
	} catch (error) {
		console.error(error); 
		 
	}

}
 
export const getMedia= async ( id:object) => {  
	
	try {
		let x=API_SITE_CORPO.MEDIA+'/'+id 
		// console.log(x)

		let { data } = await http.get(x);
		// console.log(data);
		return data;
	} catch (error) {
		console.error(error); 
		 
	}
};
 
export const savemedia = async ( objectpage:object) => {  
	// console.log(objectpage)
	
	try {
		let x=API_SITE_CORPO.MEDIAUPLOAD   
		let { data } = await httpwithtoken.post(x,objectpage);
		return data;
	} catch (error) {
		console.error(error); 
		 
	}
};
export const editmedia = async ( objectpage:any) => {  
	
	try {
		// console.log(objectpage)
		let x=API_SITE_CORPO.PAGE +"/"+  objectpage.id
		let { data } = await httpwithtoken.put(x,objectpage);
		return data;
	} catch (error) {
		console.error(error); 
		 
	}
};

export const deletedmedia = async ( id:any) => {  
	
	try {
		let x=API_SITE_CORPO.MEDIADELETED + id
		let { data } = await httpwithtoken.delete(x);
		return data;
	} catch (error) {
		console.error(error); 
		 
	}
};